<template>
  <div class="upload-box">
    <div v-if="!processingUpload" class="upload-box__upload-place" @drop.stop.prevent="dropContent($event)" @dragover.prevent>
      <div class="upload-box__upload-place__info">
        <div class="text-wrapper">
          <h2 class="small-title">Drop files anywhere to upload</h2>
          <span class="or-text">or</span>
        </div>
        <div class="text-wrapper-mobile">
          <h2 class="small-title">Choose file to upload</h2>
        </div>
        <div class="files-wrapper">
          <input type="file" id="file" @change="addContent($event)" accept="image/*" class="inputfile" multiple>
          <label for="file" class="small-font">Select files</label>
        </div>
        <div class="upload-box__upload-place__detail">
          <p class="regular-font align-center">You are using multi-file uploader. Problems? try select files instead.</p>
          <p class="regular-font align-center">Allowable file type .jpg, .jpeg, .png</p>
        </div>
      </div>
    </div>
    <div v-else class="upload-box__uploading">
      <ul class="upload-box__uploading__list">
        <li v-for="file in listUploadFile" :key="file.id" class="upload-box__uploading__list__file">
          <div class="upload-box__uploading__list__file__info">
            <div class="left-info">
              <span class="filename subhead">{{file.name}}</span>
            </div>
            <div class="right-info">
              <span v-show="!file.error && !shouldRetry(file.id)" :ref="file.id" class="percentage">0 %</span>
              <span class="retry subhead" v-show="file.error && shouldRetry(file.id)" @click.stop="retry(file.id)">Retry
                <i class="icon-refresh"></i>
              </span>
              <span v-if="!file.error && !file.finish" class="filesize align-right">{{fileSizeConverter(file.size)}}</span>
              <span v-if="!file.finish" class="close-action" @click.stop="cancelUpload(file, file.source)"><i class="icon-close"></i></span>
            </div>
          </div>
          <adx-progress-bar
            :ref="`bar_${file.id}`"
            v-if="!file.error && !file.finish"
          />
          <p v-else class="error-text small-font">{{file.message}}</p>
          <p v-if="file.finish" class="success-text small-font">File Uploaded</p>
          <p v-if="listMissMatch.includes(file.id)" class="success-miss small-font">Miss match orientation, please upload {{orientation}} content.</p>
        </li>
      </ul>
    </div>
    <div class="upload-box__footer">
      <div v-if="processingUpload" class="upload-box__footer__action">
        <div class="upload-box__footer__action__left">
          <div class="files-wrapper">
            <input type="file" id="file" @change="addContent($event)" accept="image/*" class="inputfile" :disabled="isUpload" multiple>
            <label for="file" :class="['small-font', isUpload ? 'disabled' : '']">Add more</label>
          </div>
        </div>
        <div class="upload-box__footer__action__right">
          <button type="button" class="secondary btn-small" @click.stop="cancelAll()">Cancel</button>
          <button type="button" class="primary btn-small" @click.stop="done()" :disabled="isUpload">Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ProgressBar from '@/components/ProgressBar'
import { sizeConverter } from '@/lib/util'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { baseUri, accessToken } from '@/lib/config'
import store from '@/store'

export default {
  name: 'adx-other-upload',
  components: {
    'adx-progress-bar': ProgressBar
  },
  props: {
    orientation: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      processingUpload: false,
      isUpload: false,
      uploadAllowed: false,
      listUploadFile: [],
      listValidFile: [],
      listValidFileUploaded: [],
      listRetry: [],
      listMissMatch: [],
      counterFile: 0,
    }
  },
  computed: {

  },
  watch: {
    listValidFileUploaded: function (newData, oldData) {
      if (newData.length == this.listValidFile.length) {
        this.isUpload = false
        this.uploadAllowed = false
      }
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {
    this.$nextTick(() => {
      if (!this.isUpload && this.uploadAllowed) {
        this.upload();
      }
    })
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    done() {
      this.$emit('done')
    },
    dropContent(event) {
      this.processingUpload = true
      this.processFiles(event.dataTransfer.files)
    },
    addContent(event) {
      this.processingUpload = true
      this.processFiles(event.target.files)
    },
    processFiles(content_files) {
      this.listValidFile = []
      this.listValidFileUploaded = []
      for (let i=0; i < content_files.length; i++) {
        this.counterFile += 1
        content_files[i].id = this.counterFile
        let validated_data = this.validateFile(content_files[i])
        if (!validated_data.is_valid) {
          content_files[i].error = true
          content_files[i].finish = false
          content_files[i].message = validated_data.message
        } else {
          let CancelToken = axios.CancelToken
          let source = CancelToken.source()
          content_files[i].error = false
          content_files[i].finish = false
          content_files[i].source = source
          this.listValidFile.push(content_files[i])
        }
        this.listUploadFile.unshift(content_files[i])
      }

      if (this.listValidFile.length > 0) {
        this.uploadAllowed = true
      }
    },
    validateFile(file) {
      let maxSize = 100000000; // 100MB
      let data = { is_valid: true }
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
        }
      } else {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
      }
      if (file.size > maxSize) {
        data.is_valid = false
        data.message = `File shouldn't more than ${util.sizeConverter(maxSize)}`
        return data
      }
      const filename = file.name.split('.')[0]
      if (filename.length > 44) {
        data.is_valid = false
        data.message = 'File name is too long. Maximum size 44 character'
        return data
      }

      return data
    },
    upload() {
      this.isUpload = true
      this.listValidFile.reverse().map((file, index) => {
        this.requestUpload(file)
      });
    },
    requestUpload(file) {
      let _this = this
      let form = new FormData();
      if (/image/.test(file.type)) {
        form.append('image', file);
      }
      form.append('title', file.name);
      (async () => {
        try {
          const token = store.getters.token
          let response = await axios.post(apiV2.newCollectionImage, form, {
            baseURL: baseUri,
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            },
            requestId: 'file-upload',
            onUploadProgress: progressEvent => {
              if (_this.$refs[file.id] && navigator.onLine) {
                let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                _this.$refs[file.id][0].innerHTML = `${percentage.toString()} %`
                _this.$refs[`bar_${file.id}`][0].$data.dataWidth = percentage
                if (percentage == 100 && !this.listValidFileUploaded.includes(file.id)) {
                  _this.listValidFileUploaded.push(file.id)
                  file.finish = true
                  _this.listUploadFile.map((item, index) => {
                    if (item.id == file.id) {
                      _this.listUploadFile[index] = file
                    }
                  })
                }
              }
            },
            cancelToken: file.source.token
          })
          if (response.status == 201) {
            const orientation = response.data.orientation_display.toLowerCase()
            if (this.orientation != '' && this.orientation != orientation) {
              _this.listMissMatch.push(file.id)
            }
          }
        } catch (err) {
          if (axios.isCancel(err)) {

          } else if (!err.response) {
            _this.listRetry.push(file)
            _this.listValidFile.map((item, index) => {
              if (item.id == file.id) {
                _this.listValidFile.splice(index, 1)
              }
            })
            if (_this.isFinish()) {
              _this.isUpload = false
              _this.uploadAllowed = false
            }
            // if (this.listValidFileUploaded.length ==
            // (this.listValidFile.length - this.listRetry.length)) {
            //   this.isUpload = false
            //   this.uploadAllowed = false
            // }
            file.error = true
            file.message = 'Connection Error'
            _this.listUploadFile.map((item, index) => {
              if (item.id == file.id) {
                _this.listUploadFile[index] = file
              }
            });
          }
        }
      })();
    },
    cancelUpload(oldFile, source) {
      this.listValidFile.map((file, index) => {
        if (file.id == oldFile.id) {
          this.listValidFile.splice(index, 1);
        }
      });
      this.listUploadFile.map((file, index) => {
        if (file.id == oldFile.id) {
          this.listUploadFile.splice(index, 1);
        }
      });
      if (!oldFile.error) {
        source.cancel();
      }

      if (this.isFinish()) {
        this.isUpload = false
        this.uploadAllowed = false
      }

      // if (this.listValidFile.length == 0 ||
      // (this.listValidFile.length == this.listValidFileUploaded.length)) {
      //   this.isUpload = false;
      //   this.uploadAllowed = false;
      // }
    },
    retry(id) {
      this.isUpload = true;
      let retry_file = this.listRetry.filter(file => file.id == id)[0];
      this.listRetry.map((file, index) => {
        if (file.id == id) {
          this.listRetry.splice(index, 1)
        }
      });
      this.listUploadFile.map((file, index) => {
        if (file.id == id) {
          file.error = false
          file.message = ''
          file.finish = false
          this.listUploadFile[index] = file
        }
      });
      this.listValidFile.push(retry_file)
      this.requestUpload(retry_file)
    },
    cancelAll() {
      this.listValidFile.map((file, index) => {
        file.source.cancel();
      });

      this.closeModal();
    },
    closeModal() {
      this.$parent.closeModal()
    },
    fileSizeConverter(fileSize) {
      return sizeConverter(fileSize)
    },
    hasUploaded(id) {
      if (this.listValidFileUploaded.includes(id)) {
        return true
      }

      return false
    },
    shouldRetry(id) {
      let file = this.listRetry.filter(file => file.id == id)[0]
      if (file) {
        return true
      }

      return false
      // if (this.listRetry.includes(id)) {
      //   return true
      // }

      // return false
    },
    isFinish() {
      if (this.listValidFile.length == this.listValidFileUploaded.length) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
